import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatRadioChange } from "@angular/material/radio";
import { GroupedTreeNode, ITreeNode } from "src/app/core/datasets/tree.interface";



@Component({
  selector: 'mood-select-category-tree-node',
  templateUrl: './select-category-tree-node.component.html',
  styleUrls: ['./select-category-tree-node.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectCategoryTreeNodeComponent {
  @Input() node!: ITreeNode;
  @Input() nodeToDisable?: string;
  @Input() forceDisable?: boolean;
  @Input() selectedNode!: string | null;
  @Output() selectedNodeChange = new EventEmitter();

  public get childNodes() {
    return (this.node as GroupedTreeNode).children || [];
  }

  public get categoryId() {
    return (this.node as GroupedTreeNode).category_id;
  }

  public get isChecked() {
    return (this.node as GroupedTreeNode).category_id === this.selectedNode;
  }

  public selectionChanged(event: MatRadioChange) {
    this.selectedNodeChange.emit(event.value);
  }

  public emitSelectedNode(event: string) {
    this.selectedNodeChange.emit(event);
  }

  public get disableNodeAndChildren() {
    return this.forceDisable || (this.categoryId === this.nodeToDisable);
  }
}
